import { Tooltip } from "@mui/material";
import IconButton from "core/components/IconButton";
import { AnimatePresence, motion } from "framer-motion";
import "./BottomSheet.css";

export type BottomSheetProps = {
	open: boolean;
	onClose: () => void;
	title: string;
	children: React.ReactNode;
	maxHeight?: string;
};

function BottomSheet({
	open,
	onClose,
	title,
	children,
	maxHeight,
}: BottomSheetProps) {
	return (
		<AnimatePresence>
			{open && (
				<motion.div
					className="bottom-sheet-overlay"
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					onClick={onClose}
				>
					<motion.div
						className="bottom-sheet"
						initial={{ y: "100%" }}
						animate={{ y: 0 }}
						exit={{ y: "100%" }}
						transition={{ type: "spring", stiffness: 300, damping: 30 }}
						onClick={(e) => e.stopPropagation()}
						style={{ maxHeight: maxHeight || "60vh" }}
					>
						<div className="bottom-sheet-header">
							<strong>{title}</strong>
							<Tooltip title={<p>Limpar Filtro</p>}>
								<motion.div
									initial={{ rotate: 0 }}
									whileHover={{ rotate: 90 }}
									transition={{ duration: 0.2, ease: "easeInOut" }}
									className="select-field-chevron"
								>
									<IconButton
										icon="X"
										size="xl"
										onClick={onClose}
										borderColor="rgba(50, 50, 50, 0)"
										backgroundColor="rgba(0, 0, 0, 0)"
										theme="dark"
									/>
								</motion.div>
							</Tooltip>
						</div>
						<div className="bottom-sheet-body">{children}</div>
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export default BottomSheet;
